// import gsap from 'gsap'
import './testimonialSlider.css'
import { addStaticSplideClasses, bp, dev, mm, onDomReady, sel, selAll, stResizeObserver } from '../utils'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Splide from '@splidejs/splide'
import '@splidejs/splide/css'

// gsap.registerPlugin(ScrollTrigger)
export default function TestimonialSlider() {
  const testimonials$ = sel('.testimonial-slider')

  if (!testimonials$) return
  console.log('Init testimonial slider')

  const ua = navigator.userAgent
  const isSafari = /Safari\//.test(ua) && !/Chrome\//.test(ua) && !/Chromium\//.test(ua)
  if (isSafari) {
    testimonials$.style.setProperty('--card-blur', '0px')
  }

  addStaticSplideClasses(testimonials$, '.testimonial-slider__tracker')

  const slider = new Splide(testimonials$, {
    arrows: false,
    pagination: false,
    // type: 'fade',
    gap: '4rem',
    perPage: 1,
    type: 'loop',
    speed: 4000,
    // interval: 1000,
    autoplay: dev ? false : true,
    easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
    dragMinThreshold: {
      mouse: 50,
      touch: 50,
    },
    breakpoints: {
      768: {
        speed: 1000,
        // easing: 'ease-out',
      },
    },
    // drag: false,
  }).mount()
  testimonials$.splide = slider
  // slider.Components.Autoplay.pause()

  // ===== Utilities =====
  const rootFont = () => parseFloat(getComputedStyle(document.documentElement).fontSize)
  const toPx = (len, base = rootFont()) => {
    if (typeof len === 'number') return len
    const v = String(len).trim()
    if (v.endsWith('rem')) return parseFloat(v) * base
    if (v.endsWith('px')) return parseFloat(v)
    return parseFloat(v) || 0 // fallback assumes px
  }
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n))
  const setAttr = (el, name, val) => el.setAttribute(name, String(val))
  const prec = (n) => Number(n.toFixed(6))

  // ===== Main: compute FRACTIONS for the objectBoundingBox mask =====
  const target = sel('.testimonial-slider__item__c')
  const hole = document.querySelector('#cutout-1 #hole') // the rect inside the mask

  function updateMaskFractions() {
    if (!target || !hole) return
    const { width: W, height: H } = target.getBoundingClientRect()
    if (!W || !H) return

    const cs = getComputedStyle(target)
    const insetX = toPx(cs.getPropertyValue('--inset-x'))
    const insetY = toPx(cs.getPropertyValue('--inset-y'))
    const radius = toPx(cs.getPropertyValue('--radius'))

    // Convert to 0..1 fractions for objectBoundingBox coords
    const xFrac = clamp(insetX / W, 0, 0.4999)
    const yFrac = clamp(insetY / H, 0, 0.4999)
    const wFrac = clamp(1 - 2 * xFrac, 0, 1)
    const hFrac = clamp(1 - 2 * yFrac, 0, 1)

    // Keep corners visually circular after non-uniform scaling:
    // rx = r / W  and  ry = r / H  (cap at half side length per axis)
    let rxFrac = radius / W
    let ryFrac = radius / H
    rxFrac = Math.min(rxFrac, wFrac / 2)
    ryFrac = Math.min(ryFrac, hFrac / 2)

    // Write fractions to the mask rect
    setAttr(hole, 'x', prec(xFrac))
    setAttr(hole, 'y', prec(yFrac))
    setAttr(hole, 'width', prec(wFrac))
    setAttr(hole, 'height', prec(hFrac))
    setAttr(hole, 'rx', prec(rxFrac))
    setAttr(hole, 'ry', prec(ryFrac))
  }

  // Run now and on resize / font load (rem changes)
  const ro = new ResizeObserver(updateMaskFractions)
  ro.observe(target)
  window.addEventListener('resize', updateMaskFractions, { passive: true })
  if (document.fonts?.ready) document.fonts.ready.then(updateMaskFractions)
  updateMaskFractions()
}
